import React from 'react'
import {MobileMenu} from 'components/MainMenu/MainMenu'

export default class OffCanvas extends React.Component{
  render() {
    return(
      <div className="off-canvas-wrapper">
        <div className="ghost-image"></div>
        <div className="inn">
          <MobileMenu />
          <div className="motto">
            <p>We believe your ideas are worth sketching.</p>
            <p>Sketchize © 2018</p>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OffCanvas/OffCanvas.js